import React from 'react';
import { FontWeights, Stack, Text, DefaultPalette } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const titleStyles = {
  root: {
    color: DefaultPalette.neutralPrimary,
    fontSize: 32,
    fontWeight: FontWeights.semibold
  }
};
const subtitleStyles = {
  root: {
    fontSize: 14,
    fontWeight: FontWeights.regular,
    color: DefaultPalette.neutralSecondary
  }
};
export const PageHeader = props => {
  const {
    title,
    subtitle,
    styles
  } = props;
  return /*#__PURE__*/_jsxs(Stack, {
    styles: styles,
    children: [/*#__PURE__*/_jsx(Text, {
      styles: titleStyles,
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      styles: subtitleStyles,
      children: subtitle
    })]
  });
};
const pageHeaderDefaultStyles = {
  root: {
    paddingBottom: 10
  }
};
PageHeader.defaultProps = {
  styles: pageHeaderDefaultStyles
};